var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#6C45DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7841 7.4565V11.7726L8.99831 14.544L4.21031 11.7726V6.22969L9 3.45375L12.6782 5.58563L13.2339 5.265L9 2.8125L3.65625 5.90625V12.0938L9 15.1875L14.3438 12.0938V7.13587L13.7841 7.4565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65956 11.7765H6.85969V9.08214H9.52875C9.65409 9.08109 9.77798 9.05531 9.89333 9.00627C10.0087 8.95724 10.1132 8.88591 10.2009 8.79639C10.3793 8.61639 10.4777 8.37283 10.4799 8.1197C10.4807 7.99442 10.4562 7.87027 10.4078 7.75468C10.3595 7.63909 10.2884 7.53443 10.1987 7.44695C10.1114 7.35811 10.0074 7.28738 9.89269 7.23883C9.77769 7.18981 9.65375 7.16529 9.52875 7.16683H6.85969V6.34727H9.53044C9.99731 6.34952 10.4473 6.53852 10.7758 6.86927C11.1077 7.20114 11.2933 7.65002 11.2973 8.1197C11.2995 8.47827 11.1904 8.82869 10.9851 9.12264C10.7955 9.40277 10.5283 9.62327 10.2161 9.75489C9.9075 9.85287 9.58537 9.90166 9.26156 9.89945H7.65956V11.7765ZM11.2781 11.7085H10.3444L9.62381 10.4485C9.90881 10.4309 10.1899 10.3729 10.4586 10.2763L11.2781 11.7085ZM13.2261 6.55989L13.7784 6.86702L14.3297 6.55989V5.90852L13.7784 5.58789L13.2261 5.90852V6.55989Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRay);
export default __webpack_public_path__ + "static/media/ray.ea6fff39bd2edf6362f5a3ba879c7a07.svg";
export { ForwardRef as ReactComponent };